<section class="initials-monogram label-small" [ngClass]="colorClasses[index() % colorClasses.length]">{{userInitials(user())}}</section>